export default "__VITE_ASSET__8eca3fd9__"